"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalitySearchExisting = void 0;
var risks_1 = require("../../interfaces/risks");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var multiSelect_1 = require("../lib/multiSelect");
var buttons_1 = require("../buttons");
var causalityDisplay_1 = require("./causalityDisplay");
var CausalitySearchExisting = (function (_super) {
    __extends(CausalitySearchExisting, _super);
    function CausalitySearchExisting(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchTerm: "",
            statuses: risks_1.CausalityStatusChoices.INCOMPLETE,
        };
        _this.props.onSearchChange(_this.state);
        return _this;
    }
    CausalitySearchExisting.prototype.handleSearchTerm = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            searchTerm: value
        });
    };
    CausalitySearchExisting.prototype.handleStatusChange = function (value, checked) {
        var status = parseInt(value);
        var statuses = this.state.statuses;
        if (checked) {
            statuses.push(status);
        }
        else {
            statuses.splice(this.state.statuses.indexOf(status), 1);
        }
        this.setState({
            statuses: statuses
        });
    };
    CausalitySearchExisting.prototype.onCheckAllStatuses = function () {
        this.setState({
            statuses: risks_1.CausalityStatusChoices.toList()
        });
    };
    CausalitySearchExisting.prototype.onUncheckAllStatuses = function () {
        this.setState({
            statuses: []
        });
    };
    CausalitySearchExisting.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var classes = props.loading ? "InputText--loading form-control" : "form-control";
        console.log(props);
        return (React.createElement("div", null,
            React.createElement("div", { className: "form-group" },
                React.createElement("label", null, gettext("Search")),
                React.createElement("input", { type: "text", onChange: this.handleSearchTerm.bind(this), className: classes })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", null,
                    gettext("Status"),
                    ":"),
                React.createElement(multiSelect_1.Multiselect, { name: "status", choices: risks_1.CausalityStatusChoices.as_choices(), value: this.state.statuses.map(function (s) { return s.toString(); }), onSingleChange: this.handleStatusChange.bind(this), onCheckAll: this.onCheckAllStatuses.bind(this), onUncheckAll: this.onUncheckAllStatuses.bind(this), selectedText: gettext('status(es) selected'), noneSelectedText: gettext("Select statuses"), classes: "MultiSelect__Button gm--fullwidth" })),
            React.createElement("div", { className: "form-group" },
                React.createElement(buttons_1.PrimaryButton, { onClick: function () { _this.props.onSearchChange(_this.state); }, noHMargin: true }, gettext("Search"))),
            React.createElement("div", { className: "CausalityDialog__SearchResultList" },
                React.createElement("ul", { className: "list-unstyled" }, props.searchResults.length ?
                    props.searchResults.map(function (causality) {
                        return (React.createElement("li", { key: causality.id, className: "CausalityContainer__SearchResult", onClick: function (e) { return props.attachCausality(causality); } },
                            React.createElement(causalityDisplay_1.CausalityDisplay, { causality: causality, display_title: true })));
                    })
                    :
                        React.createElement("span", null, pgettext("Search matches", "No matches"))))));
    };
    CausalitySearchExisting = __decorate([
        mobx_react_1.observer
    ], CausalitySearchExisting);
    return CausalitySearchExisting;
}(React.Component));
exports.CausalitySearchExisting = CausalitySearchExisting;
